import { useState } from 'react';
import { Formik, FormikHelpers } from 'formik';
import { Box, Flex } from '@chakra-ui/react';
import { Button, FormSelect } from 'components/UI';
import { validateRequired } from 'utils/validation';
import { validateForm } from 'utils/helpers';
import { IOption } from 'types';

export type BulkAssignRoleFormValues = {
  role: string;
};

export type BulkAssignRoleFormProps = {
  onSubmit: (values: BulkAssignRoleFormValues, actions: FormikHelpers<BulkAssignRoleFormValues>) => void;
  options: IOption[];
};

const BulkAssignRoleForm = ({ onSubmit, options }: BulkAssignRoleFormProps) => {
  const [submitted, setSubmitted] = useState(false);
  return (
    <Formik
      initialValues={{
        role: '',
      }}
      validate={async (values) => {
        const errors = validateRequired<BulkAssignRoleFormValues>(['role'], values);
        return errors;
      }}
      onSubmit={onSubmit}
    >
      {(formConfig) => {
        const { values, handleSubmit, isSubmitting, setFieldValue, setFieldTouched } = formConfig;

        const formErrors = validateForm<BulkAssignRoleFormValues>({
          ...formConfig,
          submitted,
        });

        return (
          <form style={{ width: '100%' }} onSubmit={handleSubmit}>
            <Box mb={6}>
              <FormSelect
                name="role"
                error={formErrors.role}
                value={values.role}
                placeholder="Select the role"
                options={options}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                filterConfig={{
                  matchFrom: 'start',
                }}
              />
            </Box>

            <Flex justifyContent="flex-end">
              <Button
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                onClick={() => setSubmitted(true)}
                type="submit"
              >
                Submit
              </Button>
            </Flex>
          </form>
        );
      }}
    </Formik>
  );
};

export default BulkAssignRoleForm;
